// ChatbotWithNavigationControl.tsx
import React, {useEffect, useState} from 'react';
import {useNavigationState} from '@react-navigation/native';
import CaissaChatbot from '.';

const hideRoutes = [
  'playchess',
  'courses',
  // The masterclass player has its own coach, and the floating Caissa button
  // sits on top of it in the bottom-right corner.
  'masterclass',
  'renewal',
  'csoc-new-payment',
  'classroom',
  'studydetails',
  'clubroom',
  'puzzleroyalebattle',
  'funchallengeslobby',
  'studydetails',
  'funChallengeBattle',
  'puzzleroyaletournament',
];
const ChatbotWithNavigationControl = ({navigationRef}) => {
  const [currentRoute, setCurrentRoute] = useState();

  useEffect(() => {
    const updateCurrentRoute = () => {
      const route = navigationRef?.current?.getCurrentRoute();
      console.log('Current route:', route?.name);
      setCurrentRoute(route?.name);
    };

    updateCurrentRoute(); // Set on mount

    const unsubscribe = navigationRef?.current?.addListener?.(
      'state',
      updateCurrentRoute,
    );

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [navigationRef]);

  const shouldShowChatbot =
    currentRoute && !hideRoutes.includes(currentRoute.toLowerCase());

  console.log(currentRoute, shouldShowChatbot, 'Chatbot visibility logic');

  return shouldShowChatbot ? <CaissaChatbot /> : null;
};

export default ChatbotWithNavigationControl;
